/**
 * Format Unix timestamp to relative time (e.g., "2 hours ago")
 */
export function formatRelativeTime(timestamp: number): string {
	const now = Date.now();
	const diffMs = now - timestamp * 1000; // Convert to milliseconds
	const diffSec = Math.floor(diffMs / 1000);
	const diffMin = Math.floor(diffSec / 60);
	const diffHour = Math.floor(diffMin / 60);
	const diffDay = Math.floor(diffHour / 24);
	const diffWeek = Math.floor(diffDay / 7);
	const diffMonth = Math.floor(diffDay / 30);
	const diffYear = Math.floor(diffDay / 365);

	if (diffSec < 60) {
		return 'just now';
	}
	if (diffMin < 60) {
		return `${diffMin} minute${diffMin !== 1 ? 's' : ''} ago`;
	}
	if (diffHour < 24) {
		return `${diffHour} hour${diffHour !== 1 ? 's' : ''} ago`;
	}
	if (diffDay < 7) {
		return `${diffDay} day${diffDay !== 1 ? 's' : ''} ago`;
	}
	if (diffWeek < 4) {
		return `${diffWeek} week${diffWeek !== 1 ? 's' : ''} ago`;
	}
	if (diffMonth < 12) {
		return `${diffMonth} month${diffMonth !== 1 ? 's' : ''} ago`;
	}
	return `${diffYear} year${diffYear !== 1 ? 's' : ''} ago`;
}

/**
 * Format Unix timestamp to readable date string
 */
export function formatDate(timestamp: number): string {
	const date = new Date(timestamp * 1000);
	return date.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	});
}

/**
 * Format Unix timestamp to time string
 */
export function formatTime(timestamp: number): string {
	const date = new Date(timestamp * 1000);
	return date.toLocaleTimeString('en-US', {
		hour: '2-digit',
		minute: '2-digit',
	});
}
